(function() {
    var io = new IntersectionObserver(function(es) {
        es.forEach(function(e) {
            if (e.isIntersecting) {
                e.target.classList.add("in");
                io.unobserve(e.target);
            }
        });
    }, {
        threshold: .12
    });
    document.querySelectorAll(".rv").forEach(function(el) {
        io.observe(el);
    });
})();

//# sourceMappingURL=integration.1230cd4d.js.map
